import React, { FC, useState } from 'react';
import { QueryResult } from 'react-apollo';
import { includes } from 'lodash';

import { GroupSuggestDocument, SuggestIndex, UserSuggestDocument } from 'api';
import { withApolloClient, IWithApolloClient } from 'providers/withApolloClient';

import { ISuggestProps } from './types';
import Component from './SuggestComponent';

interface IPropsEnhanced extends ISuggestProps, IWithApolloClient {}

const INDEX = {
  group: SuggestIndex.Suggestedgroups,
  profile: SuggestIndex.Suggestedprofiles,
};

const SuggestAsync: FC<IPropsEnhanced> = props => {
  const [suggestions, setSuggestions] = useState([]);

  const {
    apolloClient,
    exclusions,
    inputValue,
    type,
    placeholder,
    onChange,
    onInputChange,
    TextFieldProps,
  } = props;

  function getQuery() {
    switch (type) {
      case 'group':
        return GroupSuggestDocument;
      case 'profile':
        return UserSuggestDocument;
    }
  }

  async function handleAsyncInputChange(nextInputValue: string) {
    onInputChange(nextInputValue);

    if (!nextInputValue.length) {
      return setSuggestions([]);
    }

    const { data }: { data: QueryResult['data'] } = await apolloClient.query({
      query: getQuery(),
      variables: { prefix: nextInputValue, index: INDEX[type] },
    });

    if (!data || !data.suggest) {
      return setSuggestions([]);
    }

    const { results } = data.suggest;
    setSuggestions(results.filter(({ id }: { id: string }) => !includes(exclusions, id)));
  }

  return (
    <Component
      type={type}
      placeholder={placeholder}
      inputValue={inputValue}
      suggestions={suggestions}
      onInputChange={handleAsyncInputChange}
      onChange={onChange}
      TextFieldProps={TextFieldProps}
    />
  );
};

export default withApolloClient(SuggestAsync);
